import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { validate } from "@iq-firebolt/validators";
import { useEffect, useState } from "react";
import getAddress from "../services/getAdress";
export default function useCEPWidget(_ref) {
  var relatedFieldsSlugs = _ref.relatedFieldsSlugs,
    modifyPayloadKeys = _ref.modifyPayloadKeys,
    value = _ref.value,
    stateFormat = _ref.stateFormat,
    manuallySetFieldError = _ref.manuallySetFieldError,
    clearManuallySetError = _ref.clearManuallySetError,
    payload = _ref.payload;
  var _useState = useState(),
    autocompletePayload = _useState[0],
    setAutoCompletePayload = _useState[1];
  useEffect(onChangeValue, [value]);
  useEffect(function () {
    updateFormPayload();
  }, [autocompletePayload]);
  function onChangeValue() {
    var _validate = validate("cep", value),
      isValid = _validate.isValid;
    if (!!value && isValid) {
      _getAddressData(value);
    }
  }
  function updateFormPayload() {
    modifyPayloadKeys(Object.assign({}, payload, autocompletePayload));
  }
  function _getAddressData(_x) {
    return _getAddressData2.apply(this, arguments);
  }
  function _getAddressData2() {
    _getAddressData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
      var _yield$getAddress, logradouro, uf, bairro, localidade, hasReturns, hasRelatedFields, _setAutoCompletePaylo;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAddress(value, stateFormat);
          case 2:
            _yield$getAddress = _context.sent;
            logradouro = _yield$getAddress.logradouro;
            uf = _yield$getAddress.uf;
            bairro = _yield$getAddress.bairro;
            localidade = _yield$getAddress.localidade;
            hasReturns = !!uf && !!localidade;
            if (!hasReturns) {
              manuallySetFieldError("CEP Inválido");
            } else {
              clearManuallySetError();
            }
            hasRelatedFields = !!(relatedFieldsSlugs !== null && relatedFieldsSlugs !== void 0 && relatedFieldsSlugs.cityFieldSlug) && !!(relatedFieldsSlugs !== null && relatedFieldsSlugs !== void 0 && relatedFieldsSlugs.stateFieldSlug) && !!(relatedFieldsSlugs !== null && relatedFieldsSlugs !== void 0 && relatedFieldsSlugs.streetFieldSlug) && !!(relatedFieldsSlugs !== null && relatedFieldsSlugs !== void 0 && relatedFieldsSlugs.neighborhoodFieldSlug);
            if (hasRelatedFields && hasReturns) {
              setAutoCompletePayload((_setAutoCompletePaylo = {}, _setAutoCompletePaylo[relatedFieldsSlugs === null || relatedFieldsSlugs === void 0 ? void 0 : relatedFieldsSlugs.cityFieldSlug] = localidade, _setAutoCompletePaylo[relatedFieldsSlugs === null || relatedFieldsSlugs === void 0 ? void 0 : relatedFieldsSlugs.streetFieldSlug] = "" + logradouro, _setAutoCompletePaylo[relatedFieldsSlugs === null || relatedFieldsSlugs === void 0 ? void 0 : relatedFieldsSlugs.stateFieldSlug] = uf, _setAutoCompletePaylo[relatedFieldsSlugs === null || relatedFieldsSlugs === void 0 ? void 0 : relatedFieldsSlugs.neighborhoodFieldSlug] = bairro, _setAutoCompletePaylo));
            }
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _getAddressData2.apply(this, arguments);
  }
}